export const handleContactRedirect = (navigate) => {
  const form = document.getElementById("request-form-id");

  if (form) {
    form.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    navigate("/contact-us");
  }
};